<template>
    <v-app>
        <header class="nav-bar d-flex justify-space-between pt-8">
            <div>
                <a href="http://tco.am/en" v-if="$route.name === 'Home'">
                    <img :src="require('@/../public/images/icons/TCO.png')" alt="tco logo" width="50px"/>
                </a>
            </div>
            <div id="__menu">
                <ul>
                    <template v-if="$route.name === 'Home'">
                        <template v-if="!AUTHENTICATED">
                            <li><router-link :to="{name: 'Login'}">{{$t('auth.login')}}</router-link></li>
                            <li><router-link :to="{name: 'Register'}">{{$t('auth.register')}}</router-link></li>
                        </template>
                        <li v-else><router-link :to="{name: 'Blog'}">{{$t('home.dashboard')}}</router-link></li>
                    </template>
                    <template v-if="$route.name !== 'AdminLogin'">
                        <v-btn v-if="$i18n.locale === 'am'" @click="setLocale('en')">EN</v-btn>
                        <v-btn v-if="$i18n.locale === 'en'" @click="setLocale('am')">AM</v-btn>
                    </template>
                </ul>
            </div>
        </header>
        <slot></slot>
    </v-app>
</template>

<script>

export default {

    methods: {
        setLocale(locale) {
            this.$router.push({params: {lang: locale}});
        },
    },

    computed: {
        layout() {
            return (this.$route.meta.layout || 'default') + '-layout';
        },

        AUTHENTICATED() {
            return localStorage.getItem('home_token') !== null;
        }
    },
    mounted() {
        console.log(`%c ${process.env.VUE_APP_NAME}`, 'color: green; font-weight: bold; font-size: 40px; text-shadow: 2px 2px #0A5222');
    }
};
</script>

<style scoped lang="scss">
//@import "../scss/pages/Home/index";

.nav-bar{
    width: 100%;
    padding: 0 50px;
}
header {
    position: absolute;
    z-index: 11;
    #__menu{
        > ul {
            display: flex;
            justify-content: flex-end;
            list-style: none;
            > li {
                margin-right: 20px;
                margin-top: 10px;
                a {
                    width: 100px;
                    height: 40px;
                    text-align: center;
                    line-height: 40px;
                    background: #0A5222;
                    display: block;
                    text-decoration: none;
                    color: #fff;
                    border-radius: 3px;
                }
                &:last-child{
                    margin-right: 0;
                }
            }
        }
    }
}
.v-btn{
    background-color: #0A5222 !important;
    color: white;
    margin-top: 10px;
    width: 100px !important;
    height: 40px !important;
    border-radius: 3px;
}

@media (max-width: 1000px){
    #__menu{
        > ul > li, .v-btn{
            margin-top: 5px !important;
        }

        a, .v-btn{
            width: 70px !important;
            height: 30px !important;
            font-size: 10px !important;
            line-height: 30px !important;
        }
    }
}

@media (max-width: 600px){
    #__menu{
        a, .v-btn{
            width: 60px !important;
            height: 25px !important;
            line-height: 25px !important;
            padding: 0 !important;
            min-width: 0 !important;
        }
    }
}

</style>
